import "./style.scss"
import Header from "../header/Heade";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import React from "react";
import Seo from "../Seo";

const PrivacyPolicy = () => {

    return <div className="our-team-container">
        <Seo title="Privacy Policy | Leader Auto Ship"
             description="How Leader Auto Ship collects, uses and protects your personal information when you request a quote or ship a vehicle with us."
             path="/privacy-policy"/>
        <header>
            <Header/>
            <Navbar/>
        </header>
        <main>
            <section className="conteiner">
                <h1 className="title was-p-strong">Leader Auto Ship Privacy Policy</h1>
                <p>Welcome! Leader Auto Ship LLC (Leader) knows that privacy is important. In order to provide you (the
                    individual inquiring about our services about accessing our site) with the best service and most
                    accurate pricing, EAS collects information about you, and we may share that information with
                    necessary
                    parties. The following privacy policy explains exactly what information we collect, why we collect
                    it,
                    and who we share it with, as well as how we keep it protected. While using our website and its
                    content,
                    you are agreeing to and consenting to the most recent version of this Policy. Should you want to
                    learn
                    and understand more about the operations of our website, certain links on our website, and specific
                    services, see our Terms &amp; Conditions.</p>
                <h4>Minors</h4>
                <p>This website and its content is not intended for those under 18 years of age. You may only use
                    services
                    provided with a parent or legal guardian&rsquo;s permission. Children 13 and younger may NOT submit
                    personal information or use our services for any reason; this website is not intended for children
                    under
                    the age of 13.</p>
                <h4>Types of Data We Collect</h4>
                <p><strong>Your Personal Information</strong></p>
                <p>Your personal information is what identifies you as a person, such as your name, phone number, home
                    or
                    work addresses, etc. We ask for these things when quoting and/or booking your order.</p>
                <h4>Your Use of Our Site</h4>
                <p>We track an algorithm of information about you, basing the algorithm off of your use of our website;
                    your
                    demography, diversion, and behaviours are used to better recognize and provide our potential
                    clientele
                    with knowledgeable information. With this, the information is inspected and collected on a gross
                    basis.
                    I.e,., the webpage you were previously on, the webpage you go to next, your specific browser, IP
                    address, and others.</p>
                <h4>Your Reviews and Posts</h4>
                <p>If you decide to disclose your information on our website, we may collect your information if you
                    leave a
                    review on our website or any of our review sites, such as Google.</p>
                <h4>Your Correspondence</h4>
                <p>By sending us text messages, emails, or other forms of personal communication, or if third parties
                    send
                    us information about a post from you, we may use that information in a specific file for you.</p>
                <h4>Log Information</h4>
                <p>We will also assemble a collection of log data when you use our website. Most of this includes:</p>
                <p>Specific information on how you&rsquo;ve used our site</p>
                <p>Device information, such as your web browser type and language</p>
                <p>Specific times you&rsquo;ve viewed specific pages</p>
                <p>Which pages on our website you viewed</p>
                <p>Your current IP address</p>
                <p>Cookies and other information that identify your device and/or browser</p>
                <p>Links and pages you visit before and after visiting our website.</p>
                <h4>Cookies</h4>
                <p>Created by a server, Cookies are sections of data collected onto your device to help websites
                    identify
                    you when you&rsquo;ve visited a website for the first time. The Cookies remember things about you
                    when
                    you revisit said webpages (i.e., pages you&rsquo;ve visited in the past, your passwords, emails,
                    etc.).
                    Leader Auto Ship LLC uses Cookies on our website; your Cookies are not stored on our website but on
                    the
                    hard drive of your device. Cookies are also helpful for us by remembering specific information about
                    you
                    which targets your interests. You are able to decline the use of Cookies, though some website use
                    may be
                    limited, and most Cookies are deleted automatically at the end of use.</p>
                <h4>How We Use Cookies</h4>
                <p>Leader Auto Ship LLC uses Cookies for keeping your accounts, data, and information private. We also
                    use
                    them to see which features are most prominent and how many users visit specific pages, as well as to
                    provide an overall pleasing experience for users.</p>
                <p><strong>There are specific categories for each Cookie we use:</strong></p>
                <p><strong>Preferences</strong></p>
                <p>These Cookies remember the settings you saved on your previous visit to the webpage (i.e., passwords,
                    colour settings, language preference).</p>
                <p><strong>Security</strong></p>
                <p>These Cookies put a stop to security risk and take action to prevent security risk.</p>
                <p><strong>Performance</strong></p>
                <p>These Cookies provide us information with which pages you&rsquo;ve reacted with, for how long,
                    etc.</p>
                <p><strong>Analytics</strong></p>
                <p>These Cookies are used to help us enhance our services and better understand our users. This is how
                    we
                    know what on our website is successful and what may need some changes.</p>
                <p><strong>Advertising</strong></p>
                <p>These Cookies are used to distribute advertisements relatable to the user based on what websites
                    and/or
                    links they have clicked on in the past. They also let us know how well our advertising campaigns are
                    working (on our own website and others).</p>
                <h4>Your Choices / Browser Cookies</h4>
                <p>Most of the time (depending on your device and/or browser), you may have the option to limit or block
                    your Cookies. Cookies are helpful when you leave a certain webpage and go back to it. Cookies are a
                    main
                    key in how we use our services; blocking or limiting them may affect the accessibility and roles of
                    our
                    services. For more details on how to block/limit your use of Cookies, follow the instructions given
                    to
                    you by your browser/device.</p>
                <h4><strong>What Do We Do With Your Information</strong></h4>
                <p><strong>To Provide Services To You</strong></p>
                <p>Leader Auto Ship LLC uses your information to provide you with our services to the best of our
                    ability
                    for normal operations; none of your information is released to others or sold by EAS for any reason
                    under any circumstance. If you do not give us the information we need, we would not be able to
                    provide
                    you with any services.</p>
                <p><strong>Administrative Notices / Consent</strong></p>
                <p>We will use your personal information (phone numbers and email addresses) to contact you regarding
                    organizational and departmental changes, promotions, and messages related to your use of our website
                    (i.e., getting a quote from our website). Should you not want to receive any of these notifications,
                    you
                    may opt out of receiving emails by clicking the unsubscribe button at the bottom of any EAS email
                    and
                    you may opt out of text messages by replying STOP to any text message. When you submit your phone
                    number
                    into our system, you are then agreeing to our Privacy Policy, and you are allowing us to make phone
                    calls and/or send text messages relevant to your use of our website. Your authorization is not a
                    confirmation of any sort of purchase. Message and data rates may apply.</p>
                <p><strong>Dispute Resolution</strong></p>
                <p>In order to settle discourse, correct issues, and enforce our Terms &amp; Conditions, we will use the
                    information about you in your file as well as other information we gather from your use on our
                    website.</p>
                <p><strong>Our Disclosure to Third Parties</strong></p>
                <p>

                    <p> We value privacy and use practices that are consistent with standards in our industry to protect
                        your privacy. We do not sell or rent any personal data and sms consent about you to any third
                        party.
                        The following describes to whom your personal data and sms consent may be disclosed:</p>

                    <ul>
                        <li>
                            <b>Third Party Service Providers Performing Services on Our Behalf. </b>
                            We may share your personal data and sms consent with our service providers to perform the
                            functions for which we engage them, including the functions described in the above section
                            entitled, “What We Do With Your Information”. For example, we may use third parties to host
                            the
                            Site or assist us in providing functionality on the Site (including chat functionality),
                            provide
                            data analysis and research Site, to send out email updates about the Site or our products
                            and
                            services, and to make automated calls with respect to our products and services or to
                            respond to
                            your inquiry. We do not share SMS consent with third parties.
                        </li>
                        <li>
                            <b>For Legal Purposes. </b>
                            We also may share information that we collect from users as needed to enforce our rights,
                            protect our property or protect the rights, property or safety of others, or as needed to
                            support external auditing, compliance and corporate governance functions. We will disclose
                            personal data and sms consent as we deem necessary to respond to a subpoena, regulation,
                            binding
                            order of a data protection agency, legal process, governmental request or other legal or
                            regulatory process. We may also share personal data sms consent as required to pursue
                            available
                            remedies or limit damages we may sustain.
                        </li>
                        <li><b>Law Enforcement. </b>
                            We may disclose any information about you to law enforcement or other government officials
                            as
                            we, in our sole discretion, believe necessary or appropriate, in connection with an
                            investigation of fraud, intellectual property infringements, or other activity that is
                            illegal
                            or may expose us to legal liability.
                        </li>
                        <li><b>Changes of Control. </b>
                            We may transfer or assign information, including your Personal Data, in connection with a
                            merger, acquisition, reorganization, liquidation, change in control or other sale by or of
                            us or
                            any affiliated entity (in each case whether in whole or in part).
                        </li>
                        <li>
                            <b>Advertisers. </b>
                            We may disclose personal information and aggregate information about our users to
                            advertisers
                            and for our marketing and promotional purposes, including to determine the effectiveness of
                            our
                            promotional campaigns.
                        </li>
                    </ul>

                    We do not share your personal data and SMS consent with third parties for those third parties’
                    direct
                    marketing purposes.
                </p>

                <h4>Law Enforcement</h4>
                <p>In the event of a legal matter that may hold us liable, (fraud, informal copyright, etc,.), we may
                    reveal
                    any personal information about you as we feel necessary or relevant.</p>
                <h4>Advertisers</h4>
                <p>For marketing purposes, we may communicate information about our users to our advertisers, though
                    none of
                    this information is your personal information and will not be sold or solicited.</p>
                <h4>No Spam</h4>
                <p>Leader Auto Ship LLC does not approve of spam. Should you not want EAS to email, text, or call you,
                    you
                    do have the right to opt-out of further communications. You may not add a Leader Auto Ship LLC agent
                    to
                    any of your communications without consent. Please do not mark any Leader Auto Ship LLC
                    communication as
                    spam, as we would be more than happy to honour your wishes and prevent any future communications.
                    You
                    just need to reach out to us and let us know.</p>
                <p><strong>Disclosures You Make to Third Parties</strong></p>
                <p>
                    Leader Auto Ship LLC will take great efforts to safeguard any kind of personal information. Leader
                    Auto
                    Ship LLC cannot ensure total security and is not responsible or accountable for any personal data
                    disclosures, including but not limited to data transfer failures, hackers, or errors caused by
                    Leader
                    Auto Ship LLC. For instance, any third party might get unauthorized access to your information using
                    our
                    website.
                </p>
                <p><strong>How We Protect Your Personal Information</strong></p>
                <p>With all forms of personal information, EAS will take extra precautions to protect it in any way. EAS
                    does not guarantee complete protection and is not responsible or liable for any personal data
                    revelations, especially any error in transmission of data, hackers, or errors due to no fault of
                    EAS.
                    For example, any third parties could illegally access your information through our website.</p>
                <h4>What You Can Do About Your Personal Information</h4>
                <p><strong>Your Rights</strong></p>
                <p>You do have specific rights pertaining to your personal data and information. These rights are
                    subject to
                    local data protection laws. Depending on the relevant and suitable laws, they may include the
                    following:</p>
                <p>Access your personal data and information by us.</p>
                <p>Correct (if not already) and assure all of your data is complete and finished.</p>
                <p>Remove your personal information (to the degree accepted by data protection laws).</p>
                <p>Regulate our use of your personal data (to the extent of laws allowing); to send your personal data
                    to
                    another party.</p>
                <p>The right to object to the processing of your personal information.</p>
                <p>The right to object to be part of an automated decision making system (online chat bot).</p>
                <p>You may withdraw your consent to share your information at any time, without affecting previous
                    lawfulness.</p>
                <p>If you are a minor or reside in the state of California who have given us personal information (or
                    any
                    information you have posted on our website), you may contact us to have your information deleted.
                    This
                    does not guarantee complete removal, as your postings may have been posted on some other website not
                    by
                    Leader Auto Ship LLC. You are authorized to ask for a list of what personal information we have
                    collected about you (unless not legally allowed; written request only).</p>
                <p>Any and all questions, comments, concerns, and requests can be sent to admin@leaderautoship.com.</p>
                <h4>Governing Law</h4>
                <p>This Privacy Policy shall be governed by the laws of the State of Ohio without regard to its conflict
                    of
                    laws principles.</p>
                <p>Your acceptance of these terms<br/> By using this Site, you signify your acceptance of this policy
                    and
                    terms of service. If you do not agree to this policy, please do not use our Site. Your continued use
                    of
                    the Site following the posting of changes to this policy will be deemed your acceptance of those
                    changes.</p>
                <p>Contacting us<br/> If you have any questions about this Privacy Policy, the practices of this site,
                    or
                    your dealings with this site, please contact us at:</p>
                <p><strong>Leader Auto Ship LLC<br/> https://leaderautoship.com/<br/> admin@leaderautoship.com<br/> 979
                    oak
                    forest Dr,<br/> Morrow Ohio 45152</strong></p>
                <p>&nbsp;</p>
            </section>
        </main>
        <footer>
            <Footer/>
        </footer>
    </div>
};

export default PrivacyPolicy